module.exports = __webpack_public_path__ + "static/media/illustration-notif.17e78dbd.png";